import { create } from 'zustand'

export interface UIState {
  sidebarOpen: boolean
  loading: boolean

  // Actions
  setSidebarOpen: (open: boolean) => void
  toggleSidebar: () => void
  setLoading: (loading: boolean) => void
}

export const useUIStore = create<UIState>((set, get) => ({
  sidebarOpen: true,
  loading: false,

  setSidebarOpen: (sidebarOpen: boolean) => set({ sidebarOpen }),

  toggleSidebar: () => set({ sidebarOpen: !get().sidebarOpen }),

  setLoading: (loading: boolean) => set({ loading }),
}))
